import React, { useState } from 'react';

const RegionCityList = ({ regions, cities, currentRegion, currentCity, onSelectRegion, onSelectCity }) => {
  const regionsWithCities = React.useMemo(() => {
    if (!regions?.length || !cities?.length) return [];
    return regions
      .map((region) => ({
        region,
        cities: cities.filter((c) => (c.region?.id ?? c.region_id) === region.id),
      }))
      .filter(({ cities }) => cities.length > 0);
  }, [regions, cities]);

  const [expandedIds, setExpandedIds] = useState(() => {
    const id = currentCity
      ? (currentCity.region?.id ?? currentCity.region_id)
      : null;
    return id ? new Set([id]) : new Set();
  });

  const toggleExpand = (e, regionId) => {
    e.stopPropagation();
    e.preventDefault();
    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(regionId)) next.delete(regionId);
      else next.add(regionId);
      return next;
    });
  };

  return (
    <>
      <div className="rcl">
        {regionsWithCities.map(({ region, cities }) => {
          const isExpanded = expandedIds.has(region.id);
          const regionSelected = currentRegion?.id === region.id && !currentCity;
          return (
            <div key={region.id} className="rcl__group">
              <div className={`rcl__row${regionSelected ? ' rcl__row--selected' : ''}`}>
                <span className="rcl__label" onClick={() => onSelectRegion(region)}>
                  {region.name}
                  {regionSelected && <i className="fas fa-check rcl__check" />}
                </span>
                <button
                  type="button"
                  className="rcl__expand-btn"
                  onClick={(e) => toggleExpand(e, region.id)}
                >
                  <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'}`} />
                </button>
              </div>
              {isExpanded && (
                <ul className="rcl__cities">
                  {cities.map((city) => {
                    const citySelected = currentCity?.id === city.id;
                    return (
                      <li
                        key={city.id}
                        className={`rcl__row${citySelected ? ' rcl__row--selected' : ''}`}
                        onClick={() => onSelectCity(city)}
                      >
                        <span className="rcl__label">
                          {city.name}
                          {citySelected && <i className="fas fa-check rcl__check" />}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          );
        })}
      </div>
      <style>{`
        .rcl__group + .rcl__group {
          border-top: 1px solid #edf4f8;
        }
        .rcl__cities {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .rcl__row {
          display: flex;
          align-items: center;
          padding: 0;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          border-top: 1px solid #edf4f8;
          user-select: none;
          background: #fff;
          list-style: none;
        }
        .rcl__group:first-child .rcl__row:first-child {
          border-top: none;
        }
        .rcl__row:hover {
          background: #f5f9fd;
        }
        .rcl__row--selected {
          background: #e3f0ff;
          color: #1767c8;
        }
        .rcl__label {
          flex: 1;
          padding: 10px 14px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .rcl__expand-btn {
          background: none;
          border: none;
          padding: 10px 14px;
          cursor: pointer;
          color: #979797;
          font-size: 11px;
          line-height: 1;
          flex-shrink: 0;
        }
        .rcl__expand-btn:focus {
          outline: none;
        }
        .rcl__expand-btn:hover {
          color: #1767c8;
        }
        .rcl__row--selected .rcl__expand-btn {
          color: #1767c8;
        }
        .rcl__cities .rcl__label {
          padding-left: 26px;
        }
        .rcl__check {
          font-size: 11px;
          color: #1767c8;
        }
      `}</style>
    </>
  );
};

export default RegionCityList;
